import { useParams } from "react-router-dom"
import Profile from "../Profile"

function ProfileAugmentation() {
  const { userId } = useParams<{ userId: string }>()

  return <Profile userId={parseInt(userId)} />
}

export default ProfileAugmentation
